<template>
  <div class="relative">
    <button v-if="showCloseButton" class="absolute top-0 right-0" @click="close">
      <CloseIcon color="#4B4C52" class="w-24 h-24" />
    </button>
    <form @submit.prevent="submit">
      <h3 class="font-medium text-m1 mr-24">{{ title }}</h3>
      <CheckmarkList :tips="tips" />
      <slot />
      <TextArea
        id="start-the-chat"
        v-model="messageBoxText"
        class="mt-16"
        :rows="4"
        propClasses="!resize-none"
        :labelName="labelName"
        :status="helperStatus"
        :helperText="helperText"
      />
      <Button value="Send" class="w-full mt-16" size="medium" :loading="loading" />
    </form>
  </div>
</template>

<script lang="ts">
import HelperStatus from '@/helpers/status';
import Button from '@/components/button/Button.vue';
import TextArea from '@/components/textarea/TextArea.vue';
import CheckmarkList from '@/components/checkmark_list/CheckmarkList.vue';
import CloseIcon from '@/graphics/icons/CloseIcon.vue';

export default {
  name: 'SendMessageInput',
  components: { TextArea, Button, CheckmarkList, CloseIcon },
  props: {
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    defaultMessage: {
      type: String,
      default: '',
    },
    tips: {
      type: Array<string>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    labelName: {
      type: String,
      required: true,
    },
    validationMessage: {
      type: String,
      default: 'Please include a message.',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      helperStatus: HelperStatus.Neutral,
      messageBoxText: this.defaultMessage,
    };
  },
  computed: {
    helperText(): string {
      if (this.helperStatus === HelperStatus.Error) {
        return this.validationMessage;
      }
      return '';
    },
    isValidMessage(): boolean {
      return this.messageBoxText.length > 0;
    },
  },
  watch: {
    // setup for parent v-model
    value(value: string) {
      this.messageBoxText = value;
    },
    messageBoxText(value: string): void {
      this.$emit('input', value);
    },
  },
  methods: {
    submit(): void {
      if (this.isValidMessage) {
        this.$emit('submit', this.messageBoxText);
      } else {
        this.helperStatus = HelperStatus.Error;
      }
    },
    close(): void {
      if (this.isValidMessage) {
        this.$emit('closeDraft');
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>
